export default __webpack_public_path__ + "static/media/addbranch.fd8beea4.png";